export class KalAutocompleteOption<T = string> {
  value: T;
  label: string;
  disabled ? = false;
}
